var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"max":30}},[_c('router-view',{key:_vm.key,attrs:{"height":_vm.height}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }